<template>

  <section class="stats-section">

    <template v-if="hasData">

      <!-- کارت‌های برترین‌ها -->
      <div
          v-if="rows.length"
          class="stat-cards"
      >

        <div class="stat-card leader">

          <span class="stat-icon">👑</span>

          <div
              v-if="leader"
              class="stat-team"
          >

            <img
                v-if="leader.logo"
                :src="leader.logo"
                :alt="leader.name"
            >

            <div>

              <small>صدرنشین</small>

              <strong>{{ teamName(leader.name) }}</strong>

              <b>{{ leader.points }} امتیاز</b>

            </div>

          </div>

        </div>

        <div
            v-if="bestAttack"
            class="stat-card"
        >

          <span class="stat-icon">⚽</span>

          <div class="stat-team">

            <img
                v-if="bestAttack.logo"
                :src="bestAttack.logo"
                :alt="bestAttack.name"
            >

            <div>

              <small>قوی‌ترین حمله</small>

              <strong>{{ teamName(bestAttack.name) }}</strong>

              <b>{{ bestAttack.goalsFor }} گل</b>

            </div>

          </div>

        </div>

        <div
            v-if="bestDefense"
            class="stat-card"
        >

          <span class="stat-icon">🛡</span>

          <div class="stat-team">

            <img
                v-if="bestDefense.logo"
                :src="bestDefense.logo"
                :alt="bestDefense.name"
            >

            <div>

              <small>بهترین دفاع</small>

              <strong>{{ teamName(bestDefense.name) }}</strong>

              <b>{{ bestDefense.goalsAgainst }} گل خورده</b>

            </div>

          </div>

        </div>

        <div
            v-if="mostWins"
            class="stat-card"
        >

          <span class="stat-icon">🔥</span>

          <div class="stat-team">

            <img
                v-if="mostWins.logo"
                :src="mostWins.logo"
                :alt="mostWins.name"
            >

            <div>

              <small>بیشترین برد</small>

              <strong>{{ teamName(mostWins.name) }}</strong>

              <b>{{ mostWins.won }} برد</b>

            </div>

          </div>

        </div>

      </div>

      <!-- آمار گل و توزیع نتایج -->
      <div
          v-if="finishedCount"
          class="panels"
      >

        <div class="panel">

          <h4>آمار گل‌های فصل</h4>

          <div class="goal-stats">

            <div class="goal-item">

              <b>{{ finishedCount }}</b>

              <small>بازی برگزارشده</small>

            </div>

            <div class="goal-item">

              <b>{{ totalGoals }}</b>

              <small>کل گل‌ها</small>

            </div>

            <div class="goal-item">

              <b>{{ avgGoals }}</b>

              <small>میانگین گل در بازی</small>

            </div>

          </div>

        </div>

        <div class="panel">

          <h4>توزیع نتایج</h4>

          <div class="dist">

            <div class="dist-row">

              <span class="dist-label">برد میزبان</span>

              <div class="dist-bar">

                <div
                    class="dist-fill home"
                    :style="{ width: dist.home + '%' }"
                ></div>

              </div>

              <b class="dist-value">{{ dist.home }}٪</b>

            </div>

            <div class="dist-row">

              <span class="dist-label">مساوی</span>

              <div class="dist-bar">

                <div
                    class="dist-fill draw"
                    :style="{ width: dist.draw + '%' }"
                ></div>

              </div>

              <b class="dist-value">{{ dist.draw }}٪</b>

            </div>

            <div class="dist-row">

              <span class="dist-label">برد مهمان</span>

              <div class="dist-bar">

                <div
                    class="dist-fill away"
                    :style="{ width: dist.away + '%' }"
                ></div>

              </div>

              <b class="dist-value">{{ dist.away }}٪</b>

            </div>

          </div>

        </div>

      </div>

      <!-- برترین بازیکنان: آقای گل و پاس گل (از رویدادهای محلی) -->
      <div
          v-if="topPlayers.scorers.length || topPlayers.assists.length"
          class="panels"
      >

        <div
            v-if="topPlayers.scorers.length"
            class="panel"
        >

          <h4>⚽ آقای گل</h4>

          <div
              v-for="(s, i) in topPlayers.scorers"
              :key="'gs' + i"
              class="tp-row"
              @click="goPlayer(s.player)"
          >

            <span class="tp-rank">{{ faNum(i + 1) }}</span>

            <span class="tp-avatar" v-if="s.player.photo"><img :src="s.player.photo" :alt="s.player.name" loading="lazy"/></span>

            <span v-else class="tp-avatar initials">{{ (s.player.name || '؟').slice(0, 2) }}</span>

            <span class="tp-name">{{ s.player.name }}</span>

            <b class="tp-val">{{ faNum(s.value) }} گل</b>

          </div>

        </div>

        <div
            v-if="topPlayers.assists.length"
            class="panel"
        >

          <h4>🅰 بهترین پاسورها</h4>

          <div
              v-for="(s, i) in topPlayers.assists"
              :key="'as' + i"
              class="tp-row"
              @click="goPlayer(s.player)"
          >

            <span class="tp-rank">{{ faNum(i + 1) }}</span>

            <span class="tp-avatar" v-if="s.player.photo"><img :src="s.player.photo" :alt="s.player.name" loading="lazy"/></span>

            <span v-else class="tp-avatar initials">{{ (s.player.name || '؟').slice(0, 2) }}</span>

            <span class="tp-name">{{ s.player.name }}</span>

            <b class="tp-val">{{ faNum(s.value) }} پاس</b>

          </div>

        </div>

      </div>

    </template>

    <div
        v-else
        class="empty-state"
    >

      📊 آماری برای این فصل موجود نیست

    </div>

  </section>

</template>

<script>

import { teamNames } from '@/utils/translations';
import api from '@/services/api';

export default {

  name: 'CompetitionStats',

  props: {

    rows: {

      type: Array,

      default: () => []

    },

    matches: {

      type: Array,

      default: () => []

    },

    competitionId: {

      type: [Number, String],

      default: null

    }

  },

  data() {

    return {

      topPlayers: { scorers: [], assists: [] }

    }

  },

  mounted() {

    this.loadTopPlayers()

  },

  methods: {

    teamName(englishName) {

      return teamNames[englishName] || englishName || 'نامشخص';

    },

    faNum(n) {

      if (n === null || n === undefined || n === '') return '—';

      return String(n).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

    },

    goPlayer(p) {

      if (p && p.slug) this.$router.push(`/player/${p.slug}`);

    },

    async loadTopPlayers() {

      if (!this.competitionId) return;

      try {

        const data = await api.getCompetitionTopPlayers(this.competitionId);

        if (data) this.topPlayers = { scorers: data.scorers || [], assists: data.assists || [] };

      } catch (e) {

        // fail-soft — نبود آمار بازیکنان صفحهٔ آمار را نمی‌شکند

      }

    }

  },

  computed: {

    hasData() {

      return this.rows.length > 0 || this.finishedCount > 0;

    },

    leader() {

      return this.rows[0] || null;

    },

    // بیشترین گل زده
    bestAttack() {

      if (!this.rows.length) return null;

      return [...this.rows].sort((a, b) =>
          (b.goalsFor || 0) - (a.goalsFor || 0))[0];

    },

    // کمترین گل خورده (فقط بین تیم‌هایی که بازی داشته‌اند)
    bestDefense() {

      const played = this.rows.filter(r => r.played > 0);

      if (!played.length) return null;

      return [...played].sort((a, b) =>
          (a.goalsAgainst ?? 999) - (b.goalsAgainst ?? 999))[0];

    },

    mostWins() {

      if (!this.rows.length) return null;

      return [...this.rows].sort((a, b) => (b.won || 0) - (a.won || 0))[0];

    },

    finishedMatches() {

      return this.matches.filter(m => m.status === 'FINISHED');

    },

    finishedCount() {

      return this.finishedMatches.length;

    },

    totalGoals() {

      return this.finishedMatches.reduce((sum, m) =>

          sum + (Number(m.home?.score ?? 0) + Number(m.away?.score ?? 0)), 0);

    },

    avgGoals() {

      if (!this.finishedCount) return '۰';

      return (this.totalGoals / this.finishedCount).toFixed(2)

          .replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

    },

    // توزیع نتایج برندهٔ خانگی / مساوی / برندهٔ مهمان
    dist() {

      if (!this.finishedCount) {

        return { home: 0, draw: 0, away: 0 };

      }

      let home = 0, draw = 0, away = 0;

      for (const m of this.finishedMatches) {

        const h = Number(m.home?.score ?? 0);

        const a = Number(m.away?.score ?? 0);

        if (h > a) home++;

        else if (h < a) away++;

        else draw++;

      }

      const pct = n => Math.round((n / this.finishedCount) * 100);

      return { home: pct(home), draw: pct(draw), away: pct(away) };

    }

  },

}

</script>

<style scoped>

.stats-section{

  display:flex;

  flex-direction:column;

  gap:16px;

}

.stat-cards{

  display:grid;

  grid-template-columns:repeat(auto-fit, minmax(230px, 1fr));

  gap:14px;

}

.stat-card{

  background:#fff;

  border-radius:18px;

  padding:18px;

  box-shadow:0 4px 12px rgba(0,0,0,.06);

  display:flex;

  align-items:center;

  gap:14px;

}

.stat-card.leader{

  background: url('~@/assets/images/header-ball-bg.svg') no-repeat left 4% center / 180px auto, linear-gradient(135deg, #022c22 0%, #064e3b 45%, #047857 85%, #059669 100%); position: relative; overflow: hidden;

  color:#fff;

}

.stat-icon{

  font-size:28px;

}

.stat-team{

  display:flex;

  align-items:center;

  gap:12px;

}

.stat-team img{

  width:44px;

  height:44px;

  object-fit:contain;

}

.stat-card.leader .stat-team img{

  filter:drop-shadow(0 0 6px rgba(255,255,255,.4));

}

.stat-team small{

  display:block;

  font-size:11.5px;

  color:#94a3b8;

}

.stat-card.leader .stat-team small{

  color:rgba(255,255,255,.75);

}

.stat-team strong{

  display:block;

  font-size:14.5px;

  font-weight:700;

  color:#0f172a;

}

.stat-card.leader .stat-team strong{

  color:#fff;

}

.stat-team b{

  display:block;

  font-size:12px;

  color:#047857;

}

.stat-card.leader .stat-team b{

  color:#bfdbfe;

}

.panels{

  display:grid;

  grid-template-columns:repeat(auto-fit, minmax(300px, 1fr));

  gap:14px;

}

.panel{

  background:#fff;

  border-radius:18px;

  padding:20px;

  box-shadow:0 4px 12px rgba(0,0,0,.06);

}

.panel h4{

  margin:0 0 16px;

  font-size:15px;

  color:#1e293b;

}

.goal-stats{

  display:grid;

  grid-template-columns:repeat(3, 1fr);

  gap:10px;

  text-align:center;

}

.goal-item{

  background:#f8fafc;

  border-radius:14px;

  padding:14px 8px;

}

.goal-item b{

  display:block;

  font-size:22px;

  color:#047857;

}

.goal-item small{

  color:#94a3b8;

  font-size:11.5px;

}

.dist{

  display:flex;

  flex-direction:column;

  gap:14px;

}

.dist-row{

  display:grid;

  grid-template-columns:80px 1fr 44px;

  align-items:center;

  gap:10px;

}

.dist-label{

  font-size:12.5px;

  color:#475569;

  font-weight:600;

}

.dist-bar{

  height:12px;

  background:#f1f5f9;

  border-radius:8px;

  overflow:hidden;

}

.dist-fill{

  height:100%;

  border-radius:8px;

  transition:width .6s ease;

}

.dist-fill.home{

  background:#047857;

}

.dist-fill.draw{

  background:#f59e0b;

}

.dist-fill.away{

  background:#10b981;

}

.dist-value{

  font-size:13px;

  color:#0f172a;

}

.empty-state{

  background:#fff;

  border-radius:18px;

  padding:70px 24px;

  text-align:center;

  color:#64748b;

}

/* برترین بازیکنان (آقای گل / پاس گل) */

.tp-row{

  display:flex;

  align-items:center;

  gap:10px;

  padding:8px 6px;

  border-radius:12px;

  cursor:pointer;

  transition:background .15s;

}

.tp-row:hover{

  background:#f8fafc;

}

.tp-rank{

  width:22px;

  text-align:center;

  color:#94a3b8;

  font-weight:700;

  font-size:13px;

  flex-shrink:0;

}

.tp-avatar{

  width:34px;

  height:34px;

  border-radius:50%;

  overflow:hidden;

  flex-shrink:0;

}

.tp-avatar img{

  width:100%;

  height:100%;

  object-fit:cover;

}

.tp-avatar.initials{

  display:flex;

  align-items:center;

  justify-content:center;

  background:#e0e7ff;

  color:#1e40af;

  font-weight:700;

  font-size:12px;

}

.tp-name{

  flex:1;

  min-width:0;

  font-size:13.5px;

  color:#111827;

  white-space:nowrap;

  overflow:hidden;

  text-overflow:ellipsis;

}

.tp-val{

  color:#059669;

  font-size:12.5px;

  flex-shrink:0;

}

@media(max-width:600px){

  .panels{

    grid-template-columns:1fr;

  }

}

</style>